import React, { useMemo } from "react";
import SeatCompactPanel from "./SeatCompactPanel";
import { actionText } from "./labels";
import { formatStackBB, translateDescrPL } from "./helpers";

// Uwaga: myMeta / myName / myUsername są opcjonalne – jeśli nie podasz, pokaże "Ty".
export default function MySeatPanelRail({
  // stack display
  stackViewMode = "chips",
  setStackViewMode,
  bbAmount = 0,

  mySeatNo,
  mySt,
  myHole,
  isDealer,
  // ✅ NEW: blinds (seat numbers)
  sbSeat,
  bbSeat,
  isMyTurn,

  // ✅ NEW: allow hiding cards row (e.g. list view shows big cards separately)
  showCards = true,

  canRevealPhase,
  hasPublicCards,
  onShowCards,

  myMeta,
  myName,
  myUsername,

  lastActionBySeat,

  // ✅ NEW: hand result
  showHandResult = false,
  bySeat,   // handResult.bySeat
  payouts,  // handResult.payouts (netto +/-)
}) {
  const stack = Number.isFinite(Number(mySt?.stack)) ? Number(mySt.stack) : null;
  const committedStreet = Number.isFinite(Number(mySt?.committedStreet))
    ? Number(mySt.committedStreet)
    : null;

  const inHand = !!mySt?.inHand;
  const folded = !!mySt?.folded;
  const sittingOut = !!mySt?.sittingOut;

  const hole = Array.isArray(myHole) ? myHole.filter(Boolean) : [];
  const cards = hole.length === 2 ? hole : [];

  const badges = useMemo(() => {
    const arr = [];
    if (isDealer) arr.push({ text: "Dealer" });
    // ✅ blinds badges (match visual seat chips)
    if (mySeatNo != null && sbSeat != null && String(mySeatNo) === String(sbSeat)) arr.push({ text: "SB" });
    if (mySeatNo != null && bbSeat != null && String(mySeatNo) === String(bbSeat)) arr.push({ text: "BB" });
    if (isMyTurn) arr.push({ text: "TURA", strong: true });
    if (sittingOut) arr.push({ text: "SIT OUT" });
    if (!inHand) arr.push({ text: "poza rozdaniem" });
    if (folded) arr.push({ text: "FOLD" });
    return arr;
  }, [isDealer, sbSeat, bbSeat, mySeatNo, isMyTurn, sittingOut, inHand, folded]);

  const baseName =
    myMeta?.name ||
    myMeta?.nick ||
    myMeta?.username ||
    myMeta?.login ||
    myMeta?.email ||
    myName ||
    myUsername ||
    "Ty";

  const title = mySeatNo != null ? `${baseName} (${mySeatNo})` : baseName;

  const lastActionText = (() => {
    if (mySeatNo == null) return null;

    const a = lastActionBySeat?.[String(mySeatNo)];
    if (!a || !a.type) return null;

    const t0 = String(a.type).toUpperCase();
    const amt = Number.isFinite(Number(a.amount)) ? Number(a.amount) : null;

    const t = t0 === "RAISE_TO" ? "RAISE" : t0;

    const label = actionText(t);
    if (!label) return null;
    if (amt == null) return label;

    const shownAmt =
      stackViewMode === "bb" && Number(bbAmount) > 0
        ? `${formatStackBB(amt, bbAmount)} BB`
        : `${amt}`;

    return `${label} ${shownAmt}`;
  })();

  const myHand = mySeatNo != null ? bySeat?.[String(mySeatNo)] : null;
  const myResultText =
    showHandResult && myHand
      ? translateDescrPL(myHand?.descr || myHand?.name || "")
      : null;

  const myDelta =
    showHandResult && mySeatNo != null
      ? Number(payouts?.[String(mySeatNo)] || 0)
      : 0;

  return (
    <SeatCompactPanel
      title={title}
      badges={badges}
      stack={stack}
      committedStreet={committedStreet}
      lastActionText={lastActionText}
      cards={cards}
      showCards={showCards}
      dense={true}
      stackViewMode={stackViewMode}
      bbAmount={bbAmount}
      onToggleStackView={() => {
        if (typeof setStackViewMode !== "function") return;
        setStackViewMode((prev) => (prev === "bb" ? "chips" : "bb"));
      }}
      canRevealPhase={canRevealPhase}
      hasPublicCards={hasPublicCards}
      onShowCards={onShowCards}
      showShowCardsButton={mySeatNo != null}
      resultText={myResultText}
      resultDelta={myDelta}
    />
  );
}